module.exports = __webpack_public_path__ + "static/media/banner.3476e71d.jpg";